/* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2023, Bulb Inc. For more information, please email contact@hellobulb.com.
*          _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*/
import {
  Directive, HostListener, ElementRef, AfterViewInit, Renderer2,
} from '@angular/core';

/**
 * Directive to show ellipses.
 */
@Directive({
  selector: '[bulbEllipsify]',
  standalone: false,
})
export class EllipsifyDirective implements AfterViewInit {
  domElement: any;

  /**
   * Default constructor.
   * @param renderer renderer
   * @param elementRef element reference
   */
  constructor(private renderer: Renderer2, private elementRef: ElementRef) {
    this.domElement = this.elementRef.nativeElement; // to get DOM element and store it in global variable
    // setting compulsory required styles to the DOM element
    const elipsifyme = {
      'text-overflow': 'ellipsis',
      overflow: 'hidden',
      'white-space': 'nowrap',
    };
    Object.keys(elipsifyme).forEach((newStyle) => {
      this.renderer.setStyle(this.domElement, `${newStyle}`, elipsifyme[newStyle]);
    });
  }

  /**
   * To check and add title attribute on the element at the time when application renders first time.
   */
  ngAfterViewInit(): void {
    // to see effect try removing below two lines and check if the title is added at the first time rendering.
    this.renderer.setProperty(this.domElement, 'scrollTop', 1);
    this.isTitleAttribute();
  }

  /**
   * To add or remove title attribute on the element when it is changing width.
   */
  @HostListener('window:resize', ['$event.target'])
  isTitleAttribute() {
    (this.domElement.offsetWidth < this.domElement.scrollWidth)
      ? this.renderer.setAttribute(this.domElement, 'title', this.domElement.textContent)
      : this.renderer.removeAttribute(this.domElement, 'title');
  }

}
